import { Injectable, OnInit } from '@angular/core';

import {
  IAppConfig
} from '../../store';
@Injectable()
export class AppConfigService implements OnInit {

  private _window: Window;

  private _appConfig: IAppConfig;

  constructor () {
    this._window = window;
    const appConfigJson = this._window['AppConfig'];
    this._appConfig = <IAppConfig>appConfigJson;
  }

  getAppConfig(): IAppConfig {
    return this._appConfig;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/appConfig.service.ts